export default __webpack_public_path__ + "static/media/12-13.6156385a.png";